export const TOGGLE_TRANSFER_KEYWORDS_TO_KEYWORD_NODE =
  'TOGGLE_TRANSFER_KEYWORDS_TO_KEYWORD_NODE'

export const TRANSFER_KEYWORDS_TO_KEYWORD_NODE =
  'TRANSFER_KEYWORDS_TO_KEYWORD_NODE'

export const TRANSFER_KEYWORDS_TO_INGREDIENT_KEYWORD_NODE =
  'TRANSFER_KEYWORDS_TO_INGREDIENT_KEYWORD_NODE'

export const TRIGGER_TRANSFER_KEYWORDS_TO_DICTIONARY_TYPE =
  'TRIGGER_TRANSFER_KEYWORDS_TO_DICTIONARY_TYPE'

export const UPDATE_TRANSFERED_KEYWORDS = {
  START: 'START_UPDATE_TRANSFERED_KEYWORDS',
  COMPLETE: 'COMPLETE_UPDATE_TRANSFERED_KEYWORDS',
  FAIL: 'FAIL_UPDATE_TRANSFERED_KEYWORDS',
}

export const CLEAR_TRANSFER_KEYWORD_ERROR = 'CLEAR_TRANSFER_KEYWORD_ERROR'
